import React, { useEffect, useState } from 'react';
import { supabase } from '../../../../supabaseClient'; // Ajuste o caminho do client se necessário
import HeroBanner from '../HeroBanner';
import CategoryRow from '../CategoryRow';
import TopRow from './TopRow';

export default function FilmesContent({ onSelectVideo, handleViewAll }: any) {
  const [loading, setLoading] = useState(true);
  const [bannerVideos, setBannerVideos] = useState<any[]>([]);
  const [top10, setTop10] = useState<any[]>([]);
  const [maisAssistidos, setMaisAssistidos] = useState<any[]>([]);
  const [acao, setAcao] = useState<any[]>([]);
  const [aventura, setAventura] = useState<any[]>([]);
  const [terror, setTerror] = useState<any[]>([]);
  const [ficcao, setFiccao] = useState<any[]>([]);
  const [nacional, setNacional] = useState<any[]>([]);
  const [doramas, setDoramas] = useState<any[]>([]);
  const [comedia, setComedia] = useState<any[]>([]);
  const [trailers, setTrailers] = useState<any[]>([]);
  const [series, setSeries] = useState<any[]>([]);
  const [novelas, setNovelas] = useState<any[]>([]);
  const [desenhos, setDesenhos] = useState<any[]>([]);
  const [ia, setIa] = useState<any[]>([]);

  useEffect(() => {
    async function fetchFilmesData() {
      setLoading(true);
      try {
        // 🚀 CONSULTAS PARALELAS AO SUPABASE BLINDADAS PARA FILMES/CINEMA:
        const [
          resBanner,
          resTop10,
          resMaisAssistidos,
          resAcao,
          resAventura,
          resTerror,
          resFiccao,
          resNacional,
          resDoramas,
          resComedia,
          resTrailers,
          resSeries,
          resNovelas,
          resDesenhos,
          resIa
        ] = await Promise.all([
          
          // 🛡️ 1. BANNER BLINDADO: Apenas categorias de Cinema/Filmes/Ação/Trailer e sem shorts
          supabase.from('videos').select('*')
            .not('is_short', 'eq', true)
            .or('category.ilike.%filmes%,category.ilike.%cinema%,category.ilike.%trailer%,category.ilike.%acao%,category.ilike.%terror%')
            .order('created_at', { ascending: false }).limit(5),
          
          // 🛡️ 2. TOP 10 COM ESCUDO: Sem jogos
          supabase.from('videos').select('*')
            .ilike('category', 'top10')
            .not('category', 'ilike', '%game%')
            .not('category', 'ilike', '%jogo%')
            .order('created_at', { ascending: false }).limit(10),
          
          // 🛡️ 3. MAIS ASSISTIDOS BLINDADO: Apenas conteúdos de filmes/cinema mais vistos
          supabase.from('videos').select('*')
            .not('is_short', 'eq', true)
            .or('category.ilike.%filmes%,category.ilike.%cinema%,category.ilike.%acao%,category.ilike.%terror%,category.ilike.%aventura%')
            .order('views_count', { ascending: false }).limit(10),
            
          // 👇 O resto das categorias continua exatamente como tinhas
          supabase.from('videos').select('*').or('category.ilike.filmes:acao,category.ilike.acao').order('created_at', { ascending: false }).limit(10),
          supabase.from('videos').select('*').or('category.ilike.filmes:aventura,category.ilike.aventura').order('created_at', { ascending: false }).limit(10),
          supabase.from('videos').select('*').or('category.ilike.filmes:terror,category.ilike.terror,category.ilike.suspense').order('created_at', { ascending: false }).limit(10),
          supabase.from('videos').select('*').or('category.ilike.filmes:ficcao,category.ilike.ficcao').order('created_at', { ascending: false }).limit(10),
          supabase.from('videos').select('*').or('category.ilike.filmes:nacional,category.ilike.nacional').order('created_at', { ascending: false }).limit(10),
          supabase.from('videos').select('*').ilike('category', 'dorama').order('created_at', { ascending: false }).limit(10),
          supabase.from('videos').select('*').or('category.ilike.filmes:comedia,category.ilike.comedia').order('created_at', { ascending: false }).limit(10),
          supabase.from('videos').select('*').ilike('category', '%trailer%').order('created_at', { ascending: false }).limit(10),
          supabase.from('videos').select('*').ilike('category', 'serie').order('created_at', { ascending: false }).limit(10),
          supabase.from('videos').select('*').ilike('category', 'novela').order('created_at', { ascending: false }).limit(10),
          supabase.from('videos').select('*').or('category.ilike.desenho,category.ilike.animacao').order('created_at', { ascending: false }).limit(10),
          supabase.from('videos').select('*').or('category.ilike.tecnologia:ia,category.ilike.ia').order('created_at', { ascending: false }).limit(10),
        ]);

        setBannerVideos(resBanner.data || []);
        setTop10(resTop10.data || []);
        setMaisAssistidos(resMaisAssistidos.data || []);
        setAcao(resAcao.data || []);
        setAventura(resAventura.data || []);
        setTerror(resTerror.data || []);
        setFiccao(resFiccao.data || []);
        setNacional(resNacional.data || []);
        setDoramas(resDoramas.data || []);
        setComedia(resComedia.data || []);
        setTrailers(resTrailers.data || []);
        setSeries(resSeries.data || []);
        setNovelas(resNovelas.data || []);
        setDesenhos(resDesenhos.data || []);
        setIa(resIa.data || []);

      } catch (err) {
        console.error("Erro ao carregar dados otimizados de filmes:", err);
      } finally {
        setLoading(false);
      }
    }

    fetchFilmesData();
  }, []);

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '100px', color: '#888', fontSize: '16px' }}>
        Carregando catálogo de filmes...
      </div>
    );
  }

  return (
    <div>
      <HeroBanner videos={bannerVideos} onPlay={onSelectVideo} onInfo={onSelectVideo} />

      <div style={{ marginTop: '20px', position: 'relative', zIndex: 5 }}>
        
        {top10.length > 0 && (
          <TopRow 
            title="🔥 Top 10 da Galera" 
            videos={top10} 
            onSelectVideo={onSelectVideo} 
            onViewAll={handleViewAll} 
          />
        )}

        {maisAssistidos.length > 0 && (
          <CategoryRow 
            title="🎬 Mais Assistidos" 
            videos={maisAssistidos} 
            onSelectVideo={onSelectVideo} 
            onViewAll={handleViewAll} 
          />
        )}
        
        {acao.length > 0 && <CategoryRow title="💥 Ação" videos={acao} onSelectVideo={onSelectVideo} onViewAll={handleViewAll} />}
        {aventura.length > 0 && <CategoryRow title="🗺️ Aventura" videos={aventura} onSelectVideo={onSelectVideo} onViewAll={handleViewAll} />}
        {terror.length > 0 && <CategoryRow title="👻 Terror & Suspense" videos={terror} onSelectVideo={onSelectVideo} onViewAll={handleViewAll} />}
        {ficcao.length > 0 && <CategoryRow title="🚀 Ficção Científica" videos={ficcao} onSelectVideo={onSelectVideo} onViewAll={handleViewAll} />}
        {nacional.length > 0 && <CategoryRow title="🇧🇷 Filmes Brasileiros" videos={nacional} onSelectVideo={onSelectVideo} onViewAll={handleViewAll} />}
        {doramas.length > 0 && <CategoryRow title="🇰🇷 Doramas" videos={doramas} onSelectVideo={onSelectVideo} onViewAll={handleViewAll} />}
        {comedia.length > 0 && comedia.length > 0 && <CategoryRow title="😂 Comédia" videos={comedia} onSelectVideo={onSelectVideo} onViewAll={handleViewAll} />}
        {trailers.length > 0 && <CategoryRow title="🎬 Lançamentos & Trailers Oficiais" videos={trailers} onSelectVideo={onSelectVideo} onViewAll={handleViewAll} />}
        {series.length > 0 && <CategoryRow title="📺 Séries" videos={series} onSelectVideo={onSelectVideo} onViewAll={handleViewAll} />}
        {novelas.length > 0 && <CategoryRow title="❤️ Novelas" videos={novelas} onSelectVideo={onSelectVideo} onViewAll={handleViewAll} />}
        {desenhos.length > 0 && <CategoryRow title="🎨 Desenhos & Animações" videos={desenhos} onSelectVideo={onSelectVideo} onViewAll={handleViewAll} />}
        {ia.length > 0 && <CategoryRow title="🤖 Inteligência Artificial" videos={ia} onSelectVideo={onSelectVideo} onViewAll={handleViewAll} />}
      </div>
    </div>
  );
}